import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, Fragment as _Fragment, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "tab-content" }
const _hoisted_2 = { class: "settings-card" }
const _hoisted_3 = { class: "fields-row" }
const _hoisted_4 = { class: "field-wrap" }
const _hoisted_5 = ["value"]
const _hoisted_6 = { class: "field-wrap" }
const _hoisted_7 = { class: "username-row" }
const _hoisted_8 = ["value", "disabled"]
const _hoisted_9 = ["disabled"]
const _hoisted_10 = { class: "field-hint" }
const _hoisted_11 = {
  key: 0,
  class: "field-hint field-hint--warn"
}
const _hoisted_12 = { class: "settings-card" }
const _hoisted_13 = { class: "media-grid" }
const _hoisted_14 = { class: "media-block" }
const _hoisted_15 = ["src"]
const _hoisted_16 = { class: "media-block" }
const _hoisted_17 = { class: "media-label-row" }
const _hoisted_18 = { class: "toggle-check" }
const _hoisted_19 = ["checked"]
const _hoisted_20 = ["src"]
const _hoisted_21 = ["disabled"]
const _hoisted_22 = { class: "settings-card" }
const _hoisted_23 = { class: "color-grid" }
const _hoisted_24 = { class: "color-block" }
const _hoisted_25 = { class: "color-fields" }
const _hoisted_26 = { class: "color-input-row" }
const _hoisted_27 = ["value"]
const _hoisted_28 = ["value"]
const _hoisted_29 = { class: "color-block" }
const _hoisted_30 = { class: "color-fields" }
const _hoisted_31 = { class: "color-label-row" }
const _hoisted_32 = { class: "toggle-check" }
const _hoisted_33 = ["checked"]
const _hoisted_34 = { class: "color-input-row" }
const _hoisted_35 = ["value", "disabled"]
const _hoisted_36 = ["value", "disabled"]
const _hoisted_37 = { class: "settings-card" }
const _hoisted_38 = { class: "report-mode-options" }
const _hoisted_39 = ["checked"]
const _hoisted_40 = ["checked"]
const _hoisted_41 = { class: "save-row" }
const _hoisted_42 = {
  key: 0,
  class: "save-success"
}
const _hoisted_43 = {
  key: 0,
  class: "save-error"
}
const _hoisted_44 = {
  key: 1,
  class: "save-error"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("section", _hoisted_2, [
      _cache[24] || (_cache[24] = _createStaticVNode("<div class=\"card-header\" data-v-1583e813><div class=\"card-icon\" data-v-1583e813><svg width=\"18\" height=\"18\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" data-v-1583e813><rect x=\"3\" y=\"3\" width=\"18\" height=\"18\" rx=\"3\" data-v-1583e813></rect><path d=\"M9 9h6M9 12h6M9 15h4\" data-v-1583e813></path></svg></div><div data-v-1583e813><h3 class=\"card-title\" data-v-1583e813>Identidade</h3><p class=\"card-desc\" data-v-1583e813>Nome exibido e endereço de acesso do sistema.</p></div></div>", 1)),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _cache[20] || (_cache[20] = _createElementVNode("label", {
            class: "field-label",
            for: "sys-name"
          }, "Nome do sistema", -1)),
          _createElementVNode("input", {
            id: "sys-name",
            class: "field-input",
            value: _ctx.form.siteName,
            type: "text",
            placeholder: "Ex: Obra Torre A",
            onInput: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update-form', { field: 'siteName', value: ($event.target as HTMLInputElement).value })))
          }, null, 40, _hoisted_5)
        ]),
        _createElementVNode("div", _hoisted_6, [
          _cache[23] || (_cache[23] = _createElementVNode("label", {
            class: "field-label",
            for: "sys-username"
          }, "Username da obra", -1)),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("input", {
              id: "sys-username",
              class: "field-input username-input",
              value: _ctx.form.systemUsername,
              type: "text",
              disabled: !_ctx.usernameEditEnabled,
              placeholder: "somente letras minúsculas",
              onInput: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onSystemUsernameInput(($event.target as HTMLInputElement).value)))
            }, null, 40, _hoisted_8),
            (_ctx.usernameEditEnabled)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createElementVNode("button", {
                    class: "inline-btn inline-btn--save",
                    type: "button",
                    onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.saveSystemUsername && _ctx.saveSystemUsername(...args)))
                  }, "Salvar"),
                  _createElementVNode("button", {
                    class: "inline-btn inline-btn--cancel",
                    type: "button",
                    onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.cancelSystemUsernameEdit && _ctx.cancelSystemUsernameEdit(...args)))
                  }, "Cancelar")
                ], 64))
              : (_openBlock(), _createElementBlock("button", {
                  key: 1,
                  class: "inline-btn",
                  type: "button",
                  disabled: _ctx.usernameActionDisabled,
                  onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.enableSystemUsernameEdit && _ctx.enableSystemUsernameEdit(...args)))
                }, "Alterar", 8, _hoisted_9))
          ]),
          _createElementVNode("p", _hoisted_10, [
            _cache[21] || (_cache[21] = _createTextVNode("Troca permitida a cada 30 dias · última troca: ", -1)),
            _createElementVNode("strong", null, _toDisplayString(_ctx.lastUsernameChangeText), 1)
          ]),
          (_ctx.usernameCooldownMessage)
            ? (_openBlock(), _createElementBlock("p", _hoisted_11, [
                _cache[22] || (_cache[22] = _createElementVNode("svg", {
                  width: "12",
                  height: "12",
                  viewBox: "0 0 24 24",
                  fill: "none",
                  stroke: "currentColor",
                  "stroke-width": "2.5"
                }, [
                  _createElementVNode("circle", {
                    cx: "12",
                    cy: "12",
                    r: "10"
                  }),
                  _createElementVNode("line", {
                    x1: "12",
                    y1: "8",
                    x2: "12",
                    y2: "12"
                  }),
                  _createElementVNode("line", {
                    x1: "12",
                    y1: "16",
                    x2: "12.01",
                    y2: "16"
                  })
                ], -1)),
                _createTextVNode(" " + _toDisplayString(_ctx.usernameCooldownMessage), 1)
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _createElementVNode("section", _hoisted_12, [
      _cache[33] || (_cache[33] = _createStaticVNode("<div class=\"card-header\" data-v-1583e813><div class=\"card-icon\" data-v-1583e813><svg width=\"18\" height=\"18\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" data-v-1583e813><circle cx=\"12\" cy=\"12\" r=\"10\" data-v-1583e813></circle><path d=\"M12 2a14.5 14.5 0 0 0 0 20 14.5 14.5 0 0 0 0-20\" data-v-1583e813></path><path d=\"M2 12h20\" data-v-1583e813></path></svg></div><div data-v-1583e813><h3 class=\"card-title\" data-v-1583e813>Aparência</h3><p class=\"card-desc\" data-v-1583e813>Logo e imagem de fundo da tela de login.</p></div></div>", 1)),
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("div", _hoisted_14, [
          _cache[27] || (_cache[27] = _createElementVNode("div", { class: "media-label-row" }, [
            _createElementVNode("span", { class: "field-label" }, "Logo"),
            _createElementVNode("span", {
              class: "field-hint",
              style: {"margin":"0"}
            }, "Ideal: 180×40 px")
          ], -1)),
          _createElementVNode("div", {
            class: _normalizeClass(["upload-zone", { 'upload-zone--has': _ctx.form.siteLogoUrl }]),
            onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.triggerLogoInput && _ctx.triggerLogoInput(...args)))
          }, [
            (_ctx.form.siteLogoUrl)
              ? (_openBlock(), _createElementBlock("img", {
                  key: 0,
                  class: "upload-preview",
                  src: _ctx.$resolveUrl(_ctx.form.siteLogoUrl),
                  alt: "logo"
                }, null, 8, _hoisted_15))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _cache[25] || (_cache[25] = _createStaticVNode("<svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"1.6\" data-v-1583e813><path d=\"M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4\" data-v-1583e813></path><polyline points=\"17 8 12 3 7 8\" data-v-1583e813></polyline><line x1=\"12\" y1=\"3\" x2=\"12\" y2=\"15\" data-v-1583e813></line></svg><span class=\"upload-hint\" data-v-1583e813>Clique para enviar</span>", 2))
                ], 64))
          ], 2),
          (_ctx.form.siteLogoUrl)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                class: "remove-btn",
                type: "button",
                onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.$emit('update-form', { field: 'siteLogoUrl', value: '' })))
              }, [...(_cache[26] || (_cache[26] = [
                _createElementVNode("svg", {
                  width: "13",
                  height: "13",
                  viewBox: "0 0 24 24",
                  fill: "none",
                  stroke: "currentColor",
                  "stroke-width": "2.2"
                }, [
                  _createElementVNode("polyline", { points: "3 6 5 6 21 6" }),
                  _createElementVNode("path", { d: "M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6" })
                ], -1),
                _createTextVNode(" Remover logo ", -1)
              ]))]))
            : _createCommentVNode("", true),
          _createElementVNode("input", {
            ref: "logoInputRef",
            class: "hidden-input",
            type: "file",
            accept: "image/*",
            onChange: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.handleLogoUpload && _ctx.handleLogoUpload(...args)))
          }, null, 544)
        ]),
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("div", _hoisted_17, [
            _cache[29] || (_cache[29] = _createElementVNode("span", { class: "field-label" }, "Plano de fundo do login", -1)),
            _createElementVNode("label", _hoisted_18, [
              _createElementVNode("input", {
                checked: _ctx.form.usePrimaryLoginBackground,
                type: "checkbox",
                onChange: _cache[8] || (_cache[8] = ($event: any) => (_ctx.$emit('update-form', { field: 'usePrimaryLoginBackground', value: ($event.target as HTMLInputElement).checked ? 'true' : 'false' })))
              }, null, 40, _hoisted_19),
              _cache[28] || (_cache[28] = _createTextVNode(" Usar cor primária ", -1))
            ])
          ]),
          _createElementVNode("div", {
            class: _normalizeClass(["upload-zone", { 'upload-zone--has': _ctx.form.loginBackgroundUrl && !_ctx.form.usePrimaryLoginBackground, 'upload-zone--disabled': _ctx.form.usePrimaryLoginBackground }]),
            onClick: _cache[9] || (_cache[9] = ($event: any) => (!_ctx.form.usePrimaryLoginBackground && _ctx.backgroundInputRef?.click()))
          }, [
            (_ctx.form.loginBackgroundUrl && !_ctx.form.usePrimaryLoginBackground)
              ? (_openBlock(), _createElementBlock("img", {
                  key: 0,
                  class: "upload-preview",
                  src: _ctx.$resolveUrl(_ctx.form.loginBackgroundUrl),
                  alt: "fundo"
                }, null, 8, _hoisted_20))
              : (_ctx.form.usePrimaryLoginBackground)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createElementVNode("div", {
                      class: "color-swatch-preview",
                      style: _normalizeStyle({ background: _ctx.pickerHex(_ctx.form.colors.primary) })
                    }, null, 4),
                    _cache[30] || (_cache[30] = _createElementVNode("span", { class: "upload-hint" }, "Usando cor primária", -1))
                  ], 64))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                    _cache[31] || (_cache[31] = _createStaticVNode("<svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"1.6\" data-v-1583e813><path d=\"M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4\" data-v-1583e813></path><polyline points=\"17 8 12 3 7 8\" data-v-1583e813></polyline><line x1=\"12\" y1=\"3\" x2=\"12\" y2=\"15\" data-v-1583e813></line></svg><span class=\"upload-hint\" data-v-1583e813>Clique para enviar</span>", 2))
                  ], 64))
          ], 2),
          (_ctx.form.loginBackgroundUrl && !_ctx.form.usePrimaryLoginBackground)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                class: "remove-btn",
                type: "button",
                onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.$emit('update-form', { field: 'loginBackgroundUrl', value: '' })))
              }, [...(_cache[32] || (_cache[32] = [
                _createElementVNode("svg", {
                  width: "13",
                  height: "13",
                  viewBox: "0 0 24 24",
                  fill: "none",
                  stroke: "currentColor",
                  "stroke-width": "2.2"
                }, [
                  _createElementVNode("polyline", { points: "3 6 5 6 21 6" }),
                  _createElementVNode("path", { d: "M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6" })
                ], -1),
                _createTextVNode(" Remover fundo ", -1)
              ]))]))
            : _createCommentVNode("", true),
          _createElementVNode("input", {
            ref: "backgroundInputRef",
            class: "hidden-input",
            type: "file",
            accept: "image/*",
            disabled: _ctx.form.usePrimaryLoginBackground,
            onChange: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.handleBackgroundUpload && _ctx.handleBackgroundUpload(...args)))
          }, null, 40, _hoisted_21)
        ])
      ])
    ]),
    _createElementVNode("section", _hoisted_22, [
      _cache[37] || (_cache[37] = _createStaticVNode("<div class=\"card-header\" data-v-1583e813><div class=\"card-icon\" data-v-1583e813><svg width=\"18\" height=\"18\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" data-v-1583e813><circle cx=\"13.5\" cy=\"6.5\" r=\"2.5\" data-v-1583e813></circle><circle cx=\"17.5\" cy=\"10.5\" r=\"2.5\" data-v-1583e813></circle><circle cx=\"8.5\" cy=\"7.5\" r=\"2.5\" data-v-1583e813></circle><circle cx=\"6.5\" cy=\"12.5\" r=\"2.5\" data-v-1583e813></circle><path d=\"M12 20c4.4 0 8-3.6 8-8h-8v8z\" data-v-1583e813></path><path d=\"M4 12c0 4.4 3.6 8 8 8v-8H4z\" data-v-1583e813></path></svg></div><div data-v-1583e813><h3 class=\"card-title\" data-v-1583e813>Cores da interface</h3><p class=\"card-desc\" data-v-1583e813>Personalização visual do sistema (sidebar, navbar, botões).</p></div></div>", 1)),
      _createElementVNode("div", _hoisted_23, [
        _createElementVNode("div", _hoisted_24, [
          _createElementVNode("div", {
            class: "color-swatch",
            style: _normalizeStyle({ background: _ctx.pickerHex(_ctx.form.colors.primary) })
          }, null, 4),
          _createElementVNode("div", _hoisted_25, [
            _cache[34] || (_cache[34] = _createElementVNode("label", {
              class: "field-label",
              for: "c-primary"
            }, "Cor primária", -1)),
            _createElementVNode("div", _hoisted_26, [
              _createElementVNode("input", {
                id: "c-primary",
                class: "field-input hex-input",
                value: _ctx.form.colors.primary,
                type: "text",
                placeholder: "#0f4c81",
                onInput: _cache[12] || (_cache[12] = ($event: any) => (_ctx.$emit('update-form', { field: 'colors.primary', value: ($event.target as HTMLInputElement).value })))
              }, null, 40, _hoisted_27),
              _createElementVNode("input", {
                class: "picker-inside",
                value: _ctx.pickerHex(_ctx.form.colors.primary),
                type: "color",
                onInput: _cache[13] || (_cache[13] = ($event: any) => (_ctx.$emit('update-form', { field: 'colors.primary', value: _ctx.normalizeHex(($event.target as HTMLInputElement).value) })))
              }, null, 40, _hoisted_28)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_29, [
          _createElementVNode("div", {
            class: "color-swatch",
            style: _normalizeStyle({ background: _ctx.form.autoSecondary ? 'linear-gradient(135deg,#ccc 50%,#eee 50%)' : _ctx.pickerHex(_ctx.form.colors.secondary) })
          }, null, 4),
          _createElementVNode("div", _hoisted_30, [
            _createElementVNode("div", _hoisted_31, [
              _cache[36] || (_cache[36] = _createElementVNode("label", {
                class: "field-label",
                for: "c-secondary"
              }, "Cor secundária", -1)),
              _createElementVNode("label", _hoisted_32, [
                _createElementVNode("input", {
                  checked: _ctx.form.autoSecondary,
                  type: "checkbox",
                  onChange: _cache[14] || (_cache[14] = ($event: any) => (_ctx.$emit('update-form', { field: 'autoSecondary', value: ($event.target as HTMLInputElement).checked ? 'true' : 'false' })))
                }, null, 40, _hoisted_33),
                _cache[35] || (_cache[35] = _createTextVNode(" Automática ", -1))
              ])
            ]),
            _createElementVNode("div", _hoisted_34, [
              _createElementVNode("input", {
                id: "c-secondary",
                class: "field-input hex-input",
                value: _ctx.form.colors.secondary,
                type: "text",
                disabled: _ctx.form.autoSecondary,
                placeholder: "#e1a12f",
                onInput: _cache[15] || (_cache[15] = ($event: any) => (_ctx.$emit('update-form', { field: 'colors.secondary', value: ($event.target as HTMLInputElement).value })))
              }, null, 40, _hoisted_35),
              _createElementVNode("input", {
                class: "picker-inside",
                value: _ctx.pickerHex(_ctx.form.colors.secondary),
                type: "color",
                disabled: _ctx.form.autoSecondary,
                onInput: _cache[16] || (_cache[16] = ($event: any) => (_ctx.$emit('update-form', { field: 'colors.secondary', value: _ctx.normalizeHex(($event.target as HTMLInputElement).value) })))
              }, null, 40, _hoisted_36)
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("section", _hoisted_37, [
      _cache[40] || (_cache[40] = _createStaticVNode("<div class=\"card-header\" data-v-1583e813><div class=\"card-icon\" data-v-1583e813><svg width=\"18\" height=\"18\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" data-v-1583e813><path d=\"M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z\" data-v-1583e813></path><polyline points=\"14 2 14 8 20 8\" data-v-1583e813></polyline><line x1=\"16\" y1=\"13\" x2=\"8\" y2=\"13\" data-v-1583e813></line><line x1=\"16\" y1=\"17\" x2=\"8\" y2=\"17\" data-v-1583e813></line><polyline points=\"10 9 9 9 8 9\" data-v-1583e813></polyline></svg></div><div data-v-1583e813><h3 class=\"card-title\" data-v-1583e813>Relatórios de Planejamento</h3><p class=\"card-desc\" data-v-1583e813>Escolha como os relatórios de obra são gerados a partir do Gantt.</p></div></div>", 1)),
      _createElementVNode("div", _hoisted_38, [
        _createElementVNode("label", {
          class: _normalizeClass(["report-mode-card", { 'report-mode-card--active': (_ctx.form.ganttReportMode || 'ia') === 'ia' }])
        }, [
          _createElementVNode("input", {
            type: "radio",
            name: "ganttReportMode",
            value: "ia",
            checked: (_ctx.form.ganttReportMode || 'ia') === 'ia',
            onChange: _cache[17] || (_cache[17] = ($event: any) => (_ctx.$emit('update-form', { field: 'ganttReportMode', value: 'ia' })))
          }, null, 40, _hoisted_39),
          _cache[38] || (_cache[38] = _createElementVNode("div", { class: "report-mode-body" }, [
            _createElementVNode("svg", {
              width: "20",
              height: "20",
              viewBox: "0 0 24 24",
              fill: "currentColor"
            }, [
              _createElementVNode("path", { d: "M12 2l1.5 4.5L18 8l-4.5 1.5L12 14l-1.5-4.5L6 8l4.5-1.5L12 2z" }),
              _createElementVNode("path", {
                d: "M19 14l.75 2.25L22 17l-2.25.75L19 20l-.75-2.25L16 17l2.25-.75L19 14z",
                opacity: ".5"
              })
            ]),
            _createElementVNode("div", null, [
              _createElementVNode("strong", null, "Modo IA"),
              _createElementVNode("span", null, "EstagIArio Joe redige e edita relatórios com linguagem natural.")
            ])
          ], -1))
        ], 2),
        _createElementVNode("label", {
          class: _normalizeClass(["report-mode-card", { 'report-mode-card--active': _ctx.form.ganttReportMode === 'offline' }])
        }, [
          _createElementVNode("input", {
            type: "radio",
            name: "ganttReportMode",
            value: "offline",
            checked: _ctx.form.ganttReportMode === 'offline',
            onChange: _cache[18] || (_cache[18] = ($event: any) => (_ctx.$emit('update-form', { field: 'ganttReportMode', value: 'offline' })))
          }, null, 40, _hoisted_40),
          _cache[39] || (_cache[39] = _createStaticVNode("<div class=\"report-mode-body\" data-v-1583e813><svg width=\"20\" height=\"20\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" data-v-1583e813><path d=\"M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z\" data-v-1583e813></path><polyline points=\"14 2 14 8 20 8\" data-v-1583e813></polyline><line x1=\"12\" y1=\"18\" x2=\"12\" y2=\"12\" data-v-1583e813></line><line x1=\"9\" y1=\"15\" x2=\"15\" y2=\"15\" data-v-1583e813></line></svg><div data-v-1583e813><strong data-v-1583e813>Modo Offline</strong><span data-v-1583e813>Relatório gerado automaticamente a partir do Gantt, sem IA, funciona sem internet.</span></div></div>", 1))
        ], 2)
      ])
    ]),
    _createElementVNode("div", _hoisted_41, [
      _createElementVNode("button", {
        class: "btn-save",
        type: "button",
        onClick: _cache[19] || (_cache[19] = ($event: any) => (_ctx.$emit('save')))
      }, [...(_cache[41] || (_cache[41] = [
        _createElementVNode("svg", {
          width: "15",
          height: "15",
          viewBox: "0 0 24 24",
          fill: "none",
          stroke: "currentColor",
          "stroke-width": "2.2"
        }, [
          _createElementVNode("path", { d: "M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z" }),
          _createElementVNode("polyline", { points: "17 21 17 13 7 13 7 21" }),
          _createElementVNode("polyline", { points: "7 3 7 8 15 8" })
        ], -1),
        _createTextVNode(" Salvar configurações ", -1)
      ]))]),
      _createVNode(_Transition, { name: "fade" }, {
        default: _withCtx(() => [
          (_ctx.successText)
            ? (_openBlock(), _createElementBlock("span", _hoisted_42, [
                _cache[42] || (_cache[42] = _createElementVNode("svg", {
                  width: "14",
                  height: "14",
                  viewBox: "0 0 24 24",
                  fill: "none",
                  stroke: "currentColor",
                  "stroke-width": "2.5"
                }, [
                  _createElementVNode("polyline", { points: "20 6 9 17 4 12" })
                ], -1)),
                _createTextVNode(_toDisplayString(_ctx.successText), 1)
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }),
      (_ctx.logoError)
        ? (_openBlock(), _createElementBlock("p", _hoisted_43, _toDisplayString(_ctx.logoError), 1))
        : _createCommentVNode("", true),
      (_ctx.errorText)
        ? (_openBlock(), _createElementBlock("p", _hoisted_44, _toDisplayString(_ctx.errorText), 1))
        : _createCommentVNode("", true)
    ])
  ]))
}